<app-nav-bar></app-nav-bar>
<div class="scheduleConference">
    <div class="split left">
    <br>
    <br>
     <span style="font-size: 30px;font-weight: 600;color: #004526;font-family: 'Rubik', sans-serif;">
    Review
    </span>
    <br>
     <br>		
        <div class="col-md-12 col-sm-12 item">
          <div class="card item-card card-block" style="border: 1px solid #87b538;border-radius: 10px;height: 177px;margin-bottom: 20px;">
            <span style="margin-left: 20px;margin-top: 20px;">						
            <i class="fa fa-star" aria-hidden="true" style="font-size: 20px; color: yellow;"></i>
            <i class="fa fa-star" aria-hidden="true" style="font-size: 20px; color: yellow;"></i>
            <i class="fa fa-star" aria-hidden="true" style="font-size: 20px; color: yellow;"></i>
            <i class="fa fa-star-half-o" aria-hidden="true" style="font-size: 20px; color: yellow;"></i>
            <i class="fa fa-star-half-o" aria-hidden="true" style="font-size: 20px; color: yellow;"></i>
            <span></span>						
            </span>					  			
          <p class="card-text" style="padding: 0 20px;margin-top: 10px;"></p> 
          <h3 class="item-card-title mt-3 mb-3" style="margin-left: 575px;font-size: 20px;"></h3>
        
        </div>
        </div>
        <br><br>
        <!-- <br><br> -->
  
        <div class="col-md-12 col-sm-12 item">
          <div class="card item-card card-block" style="border: 1px solid #87b538;border-radius: 10px;height: 177px;">
            <span style="margin-left: 20px;margin-top: 20px;">						
              <i class="fa fa-star" aria-hidden="true" style="font-size: 20px; color: yellow;"></i>
              <i class="fa fa-star" aria-hidden="true" style="font-size: 20px; color: yellow;"></i>
              <i class="fa fa-star" aria-hidden="true" style="font-size: 20px; color: yellow;"></i>
              <i class="fa fa-star-half-o" aria-hidden="true" style="font-size: 20px; color: yellow;"></i>
              <i class="fa fa-star-half-o" aria-hidden="true" style="font-size: 20px; color: yellow;"></i>						
            </span>					  			
            <!-- <p class="card-text" style="padding: 0 20px;margin-top: 10px;">This is a company that builds websites, web apps and e-commerce solutions.
              This is a company that builds websites, web apps and e-commerce solutions.
              This is a company that builds websites, web apps and e-commerce solutions.</p> 
            <h3 class="item-card-title mt-3 mb-3" style="margin-left: 575px;font-size: 20px;">showUserName</h3>
           -->
        </div>
        </div>
  
    </div>
    
  <div class="split right"> 
    <br>
    <br>
    <span style="font-size: 25px;font-weight: 600;color: #004526;font-family: 'Rubik', sans-serif;">Feedback</span>
    <br>
    <br>
    <div class="w3layouts_main wrap">
    <!-- <h3>Please help us to serve you better by taking a couple of minutes. </h3>  -->
       <form name="form" (ngSubmit)="f.form.valid && sendFeedback()" #f="ngForm" novalidate>
      <h2 style="font: 500 20px/32px Roboto, Helvetica Neue, sans-serif;letter-spacing: normal; margin: 0 0 16px;">How satisfied were you with our Service?</h2>
      <span style="font-size: 18px; font-weight: 400;">				
        <span style="margin-bottom: 10px;"> Excellent </span>
        <input type="radio" id="meet" name="ratingPoints" value="5" [(ngModel)]="model.ratingPoints">&nbsp;&nbsp; &nbsp;
        <span> Good </span>
        <input type="radio" id="web" name="ratingPoints" value="4" [(ngModel)]="model.ratingPoints">&nbsp;&nbsp;&nbsp;
        <span style="margin-bottom: 10px;"> Neutral </span>
        <input type="radio" id="meet" name="ratingPoints" value="3" [(ngModel)]="model.ratingPoints">&nbsp;&nbsp; &nbsp;
        <span> Poor </span>
        <input type="radio" id="web" name="ratingPoints" value="2" [(ngModel)]="model.ratingPoints">&nbsp;&nbsp;&nbsp;
      </span>
      <br><br><br>
        <h2 style="font: 500 20px/32px Roboto, Helvetica Neue, sans-serif;letter-spacing: normal; margin: 0 0 16px;">If you have specific feedback, please write to us...</h2>
        <span>
        <textarea id="msg" name="message" class="form-control"  placeholder="Your feedback" [(ngModel)]="model.msg" #msg="ngModel" [ngClass]="{ 'is-invalid': f.submitted && msg.invalid }" required></textarea>
        <div *ngIf="f.submitted && msg.invalid" class="invalid-feedback">
          <div *ngIf="msg.errors.required" style="font-size: 15px;">*feedback is required</div>
        </div>
        </span><br>  
        <button type="submit" class="btnSend">
        <i class="fas fa-paper-plane" aria-hidden="true" style="color: #fff;"></i> &nbsp;
        Send
        </button>
        <br> <br>
        </form>

    </div>
  </div>
  </div>